import {initElements} from "../../define/shared";

export default function initMyAccountQuestions() {
    initElements(".myAccount-questions", page => {
        const qResponse = page.querySelector(".qResponse");

        if (!qResponse) {
            return;
        }

        const buttons = qResponse.querySelectorAll("[data-response]");
        const submitBtn = qResponse.querySelector(".qResponse-text-submit");

        buttons.forEach(button => {
            button.addEventListener("click", () => {
                qResponse.classList.add("is--loading");
                fetch(window.RES.base + "wa-theme/v1/post-user-response", {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json",
                        "X-WP-Nonce": window.RES.nonce_wp,
                    },
                    body: JSON.stringify({
                        nonce: window.RES.nonce,
                        response: button.dataset.response,
                        postId: qResponse.dataset.postId
                    })
                }).then(response => response.json())
                    .then(res => {
                        qResponse.classList.remove("is--loading");
                        if (res.success) {
                            qResponse.classList.add(`is--answered-${button.dataset.response}`);
                        }
                    });
            });
        });

        submitBtn.addEventListener("click", () => {
            if (!qResponse.querySelector("textarea").value) {
                return;
            }
            qResponse.classList.add("is--loading");
            fetch(window.RES.base + "wa-theme/v1/post-user-response-text", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "X-WP-Nonce": window.RES.nonce_wp,
                },
                body: JSON.stringify({
                    nonce: window.RES.nonce,
                    postId: qResponse.dataset.postId,
                    text: qResponse.querySelector("textarea").value
                })
            }).then(response => response.json())
                .then(res => {
                    qResponse.classList.remove("is--loading");
                    if (res.success) {
                        qResponse.classList.add("is--show-text");
                    }
                });
        });

    });
}
